// iOS-Schalter (Handoff Tickets): 44×26 (klein 38×22), Knopf weiß 22/18, an = --ok, aus = --fill3.
import type { MouseEvent } from 'react';

export interface IosSchalterProps {
  an: boolean;
  onChange: (an: boolean) => void;
  /** Bezeichnung für Screenreader */
  label: string;
  klein?: boolean;
  gesperrt?: boolean;
  tip?: string;
  /** Fläche im An-Zustand (Standard --ok); die Pillen-Formulare nutzen Gold. */
  anFarbe?: string;
}

export function IosSchalter({ an, onChange, label, klein = false, gesperrt = false, tip, anFarbe }: IosSchalterProps) {
  const w = klein ? 38 : 44;
  const h = klein ? 22 : 26;
  const k = klein ? 18 : 22;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={an}
      aria-label={label}
      aria-disabled={gesperrt || undefined}
      data-tip={tip}
      onClick={(e: MouseEvent) => { e.stopPropagation(); if (!gesperrt) onChange(!an); }}
      className={gesperrt ? 'cursor-not-allowed' : 'cursor-pointer'}
      style={{
        width: w, height: h, borderRadius: h / 2, padding: 2, border: 'none', flexShrink: 0,
        display: 'flex', justifyContent: an ? 'flex-end' : 'flex-start',
        background: an ? (anFarbe ?? 'var(--ok)') : 'var(--fill3)', transition: 'background .25s', opacity: gesperrt ? 0.5 : 1,
      }}
    >
      <span style={{ width: k, height: k, borderRadius: '50%', background: '#fff', boxShadow: '0 2px 5px rgba(0,0,0,0.25)' }} />
    </button>
  );
}
